/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {ProductResource} from '../../../components/api/resources/resource/product.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-product-route-page',
  template: `
    <adn-product-list-page
      *ngIf="list"
      [list]="list">
    </adn-product-list-page>
  `
})
export class ProductRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ProductResource) private readonly Product: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !this.LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !this.LocalUserPermissions.hasNetworkPermission(PERMISSIONS.politicalAdmin.apiKey, null, 'POLITICAL');

    this.adnListHelper.setUpList(this.list, this.Product, readOnly, 'fullProductList', {
      baseTable: 'product'
    });
  }
}
